import component from './family-plan.component';
import routes from './family-plan.routes';
import familyPlanUserRegistrationDialogComponent from './family-plan-user-registration-dialog/family-plan-user-registration-dialog.component';



export default angular
  .module('fizyweb.paycell.familyplan', [])
  .component('fizyPaycellFamilyPlan', component)
  .component('familyPlanUserRegistrationDialog', familyPlanUserRegistrationDialogComponent)
  .config(routes).name;


  



// WEBPACK FOOTER //
// src/app/family-plan/family-plan.module.ts